<template>
  <div
    id="page-content"
    class="py-4 max-h-screen overflow-y-auto flex flex-col h-full"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>
